import {
  ColumnHeaderMultiSelectFilter,
  UpdateFilterType,
} from "components/ReusableHeaderFilter/ColumnHeaderMultiSelectFilter";
import {
  FILTER_BOOKS_PENDING,
  FILTER_GLOBAL_STATUS,
  STATUS_DRAFT_SHARED,
  STATUS_FILED,
  STATUS_IN_FINAL_REVIEW,
  STATUS_INFORMATION_REQUIRED,
  STATUS_INTERNAL_REVIEW,
  STATUS_MANDATORY_INFORMATION_MISSING,
  STATUS_MI_RAISED_WITH_BOOKS,
  STATUS_ON_HOLD,
  STATUS_PREPARATION_IN_PROGRESS,
  STATUS_READY_TO_FILE,
  STATUS_READY_TO_PICK,
  STATUS_UNPAID,
} from "components/TaskTracker/Task1120FilterOptions";
import { Task1120TrackerFilterType } from "components/TaskTracker/Task1120TrackerFilter";

const GLOBAL_STATUS_OPTIONS = [
  {
    value: STATUS_UNPAID,
    label: "Unpaid",
  },
  {
    value: FILTER_BOOKS_PENDING,
    label: "Books Pending",
  },
  {
    value: STATUS_MANDATORY_INFORMATION_MISSING,
    label: "Mandatory Information Missing",
  },
  {
    value: STATUS_READY_TO_PICK,
    label: "Ready to be picked",
  },
  {
    value: STATUS_PREPARATION_IN_PROGRESS,
    label: "Preparation in Progress",
  },
  {
    value: STATUS_INFORMATION_REQUIRED,
    label: "MI Raised with Client",
  },
  {
    value: STATUS_MI_RAISED_WITH_BOOKS,
    label: "MI Raised with Books",
  },
  {
    value: STATUS_INTERNAL_REVIEW,
    label: "In Review",
  },
  {
    value: STATUS_IN_FINAL_REVIEW,
    label: "In Final Review",
  },
  {
    value: STATUS_ON_HOLD,
    label: "On Hold",
  },
  {
    value: STATUS_DRAFT_SHARED,
    label: "Draft Shared",
  },
  {
    value: STATUS_READY_TO_FILE,
    label: "Ready to File",
  },
  {
    value: STATUS_FILED,
    label: "E-Filed",
  },
];

export const GlobalStatusColumnHeader = ({
  values,
  updateFilter,
}: Omit<Task1120TrackerFilterType, "updateFilter"> & {
  updateFilter: UpdateFilterType;
}) => {
  return (
    <div className="t-flex t-items-center t-justify-between t-w-full">
      <div>Global Status</div>
      <ColumnHeaderMultiSelectFilter
        filterName={FILTER_GLOBAL_STATUS}
        options={GLOBAL_STATUS_OPTIONS}
        selected={values.GLOBAL_STATUS || null}
        updateFilter={updateFilter}
        className="t-w-72"
      />
    </div>
  );
};
